import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Description = styled.div(() =>
  mq({
    color: defaultTheme.color.grayScale.dark,
    fontSize: defaultTheme.font.size.xs,
    lineHeight: defaultTheme.font.height.l,
  }),
);

export const ValdMsg = styled.p(() =>
  mq({
    fontWeight: 'bold',
    color: defaultTheme.color.error,
  }),
);
